import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { storeToRefs } from 'pinia';
import { computed, onMounted, watch } from 'vue';
import { i18n } from '@/i18n';
import { useForecastForReceiptListSelectInputStore } from './useForecastForReceiptListSelectInputStore';
import { ForecastForReceiptFormState } from '../domains/entities/ForecastForReceiptMenu';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastForReceiptSelectInput',
  props: {
    selectInputIndex: {},
    storeTag: {},
    selectedForecastForReceiptIdProp: { default: undefined },
    selectedForecastForReceiptFormState: { default: undefined },
    showLabel: { type: Boolean },
    useReset: { type: Boolean, default: true },
    reload: { type: Boolean },
    useTeleport: { type: Boolean }
  },
  emits: ["selectedForecastForReceipt", "selectedForecastForReceiptFormState"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const t = i18n.t;

const store = useForecastForReceiptListSelectInputStore(props.storeTag)();
const { state } = storeToRefs(store);

onMounted(() => {
  store.init();
  if (props.selectedForecastForReceiptIdProp) {
    state.value.selectedForecastForReceiptId = props.selectedForecastForReceiptIdProp;
  }
});

watch(
  () => props.selectedForecastForReceiptIdProp,
  (newVal) => {
    state.value.selectedForecastForReceiptId = newVal;
  }
);

watch(
  () => props.reload,
  async (newVal) => {
    if (newVal) {
      await store.reloadForecastForReceiptData();
    }
  }
);

/**
 * 受領用内示名を選択した際の処理
 * @param index - 選択した受領用内示のインデックス
 */
const onSelectedForecastForReceipt = (index: number) => {
  store.onSelectedForecastForReceipt(index);
  emits('selectedForecastForReceipt', state.value.selectedForecastForReceiptId);
  emits('selectedForecastForReceiptFormState', state.value.selectedForecastForReceiptFormState);
};

/**
 * 外すボタンを押した際の処理
 * @param value - 選択した受領用内示
 */
const onUpdatedValue = (value: string) => {
  if (value === '') {
    state.value.selectedForecastForReceiptId = undefined;
    emits('selectedForecastForReceipt', undefined);
    emits('selectedForecastForReceiptFormState', undefined);
  }
};

/**
 * セレクトボックスをクリックした際の処理
 */
const onClickSelectInput = async () => {
  await store.reloadForecastForReceiptData();
  state.value.selectInputState = true;
};

const useLabel = computed(() => (props.showLabel ? t('受領用内示') : ''));

const selectInputOptions = computed(() => {
  return [t(UNASSIGNED_COLUMN), ...store.ForecastForReceiptListNames];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectInput, {
    index: _ctx.selectInputIndex,
    "model-value": _unref(store).selectedForecastForReceipt,
    placeholder: _unref(t)('受領用内示名'),
    label: useLabel.value,
    "filter-type": 'FORECAST_FOR_RECEIPT',
    "use-reset": _ctx.useReset,
    "is-open-prop": _unref(state).selectInputState,
    "prop-options": selectInputOptions.value,
    "prop-paging-state": _unref(state).pagingState,
    "prop-paging-options": _unref(state).pagingOptions,
    "use-teleport": _ctx.useTeleport,
    "onClick:selectInput": _cache[0] || (_cache[0] = () => onClickSelectInput()),
    onClose: _cache[1] || (_cache[1] = () => (_unref(state).selectInputState = false)),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => onUpdatedValue(value)),
    "onUpdate:valueWithIndex": _cache[3] || (_cache[3] = (_, index) => onSelectedForecastForReceipt(index))
  }, null, 8, ["index", "model-value", "placeholder", "label", "use-reset", "is-open-prop", "prop-options", "prop-paging-state", "prop-paging-options", "use-teleport"]))
}
}

})